import React, { ReactElement } from "react";
import {
  DefaultHoofdstuk,
  FinancieringsopzetHoofdstuk,
  VerbouwingsSpecificatieHoofdstuk,
  SpecificatieOverwaardeHoofstuk,
} from "../../../../.generated/rapportage/rapportagetypes";
import Heading from "../../components/Heading";
import { Chapter } from "../../components/Chapter";
import { Paragraph } from "../../components/Paragraph";
import { FinancieringsopzetChapter } from "./financieringsopzet/financieringsopzet-chapter";
import { OverwaardeSpecificatieChapter } from "./overwaarde-specificatie/overwaarde-specificatie-chapter";
import { VerbouwingsSpecificatieChapter } from "./verbouwings-specificatie/verbouwings-specificatie-chapter";

type UwBenodigdeFinancieringProps = {
  uwBenodigdeFinanciering: DefaultHoofdstuk;
  financieringsopzet: FinancieringsopzetHoofdstuk | null;
  overwaardeSpecificatie: SpecificatieOverwaardeHoofstuk | null;
  verbouwingsSpecificatie: VerbouwingsSpecificatieHoofdstuk | null;
};

const UwBenodigdeFinancieringChapter = ({
  uwBenodigdeFinanciering,
  financieringsopzet,
  overwaardeSpecificatie,
  verbouwingsSpecificatie,
}: UwBenodigdeFinancieringProps): ReactElement => {
  return (
    <Chapter>
      <Heading text={uwBenodigdeFinanciering.titel ?? ""} />
      <Paragraph>
        {uwBenodigdeFinanciering.paragrafen?.p30401?.inhoud}
      </Paragraph>

      {financieringsopzet && (
        <FinancieringsopzetChapter financieringsopzet={financieringsopzet} />
      )}

      {overwaardeSpecificatie && (
        <OverwaardeSpecificatieChapter
          specificatieOverwaarde={overwaardeSpecificatie}
        />
      )}

      {verbouwingsSpecificatie && (
        <VerbouwingsSpecificatieChapter
          verbouwingsspecificatie={verbouwingsSpecificatie}
        />
      )}
    </Chapter>
  );
};

export default UwBenodigdeFinancieringChapter;
